import React, { useEffect } from 'react';
import { getApiBaseUrl } from '../../utils/apiBaseUrl';
import Logo from '../../images/logo.png'
import AuthLayout from './AuthLayout';

const AuthVerify = () => {

  useEffect(() => {
    var urlParams = new URLSearchParams(window.location.search);

    const user = {
      selector: urlParams.get('selector'),
      token: urlParams.get('token')
    };

    fetch(`${getApiBaseUrl()}v2/authentication/verify-email/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user)
    })
      .then(async (res) => {
        const text = await res.text();
        if (text && text.trim() !== '') {
          try {
            return JSON.parse(text);
          } catch (_) {
            return {};
          }
        }
        return {};
      })
      .then(() => {
        setTimeout(function() { window.location.replace('/auth/login'); }, 5000);
      })
      .catch(() => {
        // Bei Netzwerkfehler oder fehlender API-Antwort trotzdem zur Login-Seite nach Ablauf
        setTimeout(function() { window.location.replace('/auth/login'); }, 5000);
      });
  }, []);

  return (
    <AuthLayout
      logo={Logo}
      logoAlt="FireCore"
      title="Verifizierung"
      subtitle="Ihr Konto wird überprüft. Sie werden gleich weitergeleitet."
    >
      <div className="authenticate-text">
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
    </AuthLayout>
  );
};

export default AuthVerify;
